export default "__VITE_ASSET__CiKKtln1__"